import api from '../../services/api';
import { getUserId, getUserFactoryId } from '../../../index';

export async function apiGETUsers(id){
    const response = (await api.get(`traininguser/odata/?$filter=standardId eq ${id} and user/status eq true&$expand=standard($select=userId)&$expand=user($expand=companyRole, deparment; $select=name, sap)&$count=true`)).data;
    return response.value
}

export async function apiGETFunil(id) {
    const response = (await api.get(`funil/${id}`)).data    
    return  response
}

export async function apiGETFunilList() {
    const factoryId = getUserFactoryId()
    const response = (await api.get(`funil/odata/?$filter=structure/factoryId eq ${factoryId} and status eq 1&$select=id&$expand=structure($select=name)`)).data
    return response
}